export const aiToolConfig = {
  "text-to-image": {
    samplePrompt:
      "Portrait of a woman, cinematic lighting, ultra-detailed, 8k face detail",
  },
  "image-to-image": {
    samplePrompt: "Describe the image based on the input images",
  },
  "text-to-video": {
    samplePrompt:
      "A serene landscape with gentle movement, cinematic lighting, soft colors.",
  },
  "image-to-video": {
    samplePrompt: "Describe the video based on the images",
  },
  "text-to-music": {
    samplePrompt: "Define your music with style, mood, instruments, etc.",
  },
  "lyrics-to-song": {
    samplePrompt: `Type and turn your ideas into sonic masterpieces. 
e.g. A melancholic indie dream- pop song with soft male vocals, light guitars and distant reverb.Emotional and reflective.`,
    sampleLyrics: `Add your own lyrics here:
e.g. 
(Verse 1)
The ocean hums a quiet tune,
A silver song beneath the moon.
The tide pulls hard, it takes, it gives,
In every wave, my memory lives.
(Chorus)
Waves crash, hearts break,
But love's the sound they always make.
Drifting far, but never gone—
We're just waves that carry on.
(Bridge)
The sea forgets, but I still know,
Every current, every glow.
I'll fade away, but not for long—
I'll return where waves belong.`,
  },
  "watermark-remover": {
    samplePrompt: "Remove the watermark from the video",
    generateBtnLabel: "Remove Watermark",
    regenerateBtnLabel: "Remove Again",
  },
};
